<template>
	<div class="submissions">
		<RouterTabs :tabs="badgedTabs" :match-active="matchActive">
			<StrapiList
				ref="list"
				source="/submissions"
				:query="defaultQuery"
				@loading="onLoading"
				@update="onUpdate"
				@refresh="onRefresh"
			>
				<template v-slot="list">
					<SubmissionsTable v-bind="list" :campaign="campaign" />
				</template>
			</StrapiList>
			<SubmissionBatchControls
				v-if="showBatchControls"
				:campaign="campaign"
				:loading="batchProcessing"
				@update="onBatchUpdate"
			/>
		</RouterTabs>
	</div>
</template>

<script>
import { enums } from 'protoswipe-shared'
import query from '@/lib/query'
import RouterTabs from '@/components/admin/RouterTabs'
import StrapiList from '@/components/admin/StrapiList'
import SubmissionsTable from '@/components/admin/SubmissionsTable'
import SubmissionBatchControls from '@/components/admin/SubmissionBatchControls'
import api from '@/mixins/api'
import toast from '@/mixins/toast'

const { SubmissionStatus } = enums

export default {
	name: 'submissions',
	props: {
		campaign: Object,
		type: {
			type: String,
			validator: v => v in SubmissionStatus
		}
	},
	data() {
		return {
			loading: true,
			batchProcessing: false,
			submissions: [],
			tabs: [
				{
					label: 'New Submissions',
					to: query.set(this.$route, {})
				},
				{
					label: 'Approved Submissions',
					to: query.set(this.$route, {
						status: SubmissionStatus.approved,
						round: this.campaign.round
					})
				},
				{
					label: 'Declined Submissions',
					to: query.set(this.$route, {
						status: SubmissionStatus.declined,
						round: this.campaign.round
					})
				},
				{
					label: 'Previous Rounds',
					to: query.set(this.$route, {
						round_lt: this.campaign.round,
						status_ne: SubmissionStatus.new,
						round: undefined,
						status: undefined
					})
				}
			]
		}
	},
	computed: {
		campaignId() {
			return this.campaign.id || -1
		},
		defaultQuery() {
			return {
				campaign: this.campaignId,
				status: SubmissionStatus.new
			}
		},
		badgedTabs() {
			const badge = this.$store.state.api.pendingSubmissions
			return this.tabs.map(t => {
				return t.label === 'New Submissions' ? { ...t, badge } : t
			})
		},
		showBatchControls() {
			return !this.loading && this.submissions.length
		}
	},
	methods: {
		matchActive({ to }) {
			return (
				to.query.status === this.$route.query.status &&
				to.query.round_lt === this.$route.query.round_lt
			)
		},
		refresh() {
			if (this.$refs.list) this.$refs.list.refresh()
		},
		onLoading(loading) {
			this.loading = loading
		},
		onUpdate({ results }) {
			this.submissions = results
		},
		onRefresh(options) {
			this.$emit('refresh', options)
		},
		async onBatchUpdate({ query, update, successMsg, errorMsg }) {
			this.batchProcessing = true

			try {
				query = { ...this.defaultQuery, ...query }
				const body = JSON.stringify({ query, update })
				const res = await this.post('/submissions/batch', { body })
				if (res.ok) {
					this.toast(successMsg)
					this.refresh()
					this.onRefresh({ update: true })
				} else {
					this.toastErr(errorMsg)
				}
			} catch (err) {
				this.toastErr(errorMsg)
			}

			this.batchProcessing = false
		}
	},
	mixins: [api, toast],
	components: {
		RouterTabs,
		StrapiList,
		SubmissionsTable,
		SubmissionBatchControls
	}
}
</script>
